import { AccommodationStock } from '../objects/accommodationStockList';
import { AccommodationStockUpdateCriteria } from '../objects/accommodationStockUpdate';
export const updateRoomStockValue = (props: AccommodationStockUpdateCriteria, list: AccommodationStock[]): AccommodationStock[] => list.map((accommodation) => {
    if (accommodation.id === props.accommodation.id) {
        return {
            ...accommodation,
            rooms: accommodation.rooms.map((room) => {
                if (room.id === props.room.id) {
                    // if (props.stock?.value === null) {
                    //     const stocks = cloneDeep(room.room_stocks);
                    //     delete stocks[props.stock.date]
                    //     return {
                    //         ...room,
                    //         room_stocks: stocks
                    //     };
                    // }

                    // return {
                    //     ...room,
                    //     room_stocks: {
                    //         ...room.room_stocks,
                    //         [props.stock.date]: {...room.room_stocks[props.stock.date], value: props.stock.value || 0, stock_type: props.stock.stock_type || null}
                    //     }
                    // };
                    
                    return {
                        ...room,
                        room_stocks: {
                            ...room.room_stocks,
                            [props.stock.date]: props.stock
                        }
                    }
                } else {
                    return room;
                }
            })
        }
    } else {
        return accommodation;
    }
});


export const updateClientStockValue = (props: AccommodationStockUpdateCriteria , list: AccommodationStock[]): AccommodationStock[] => list.map((accommodation) => {
    if (accommodation.id === props.accommodation.id) {
        return {
            ...accommodation,
            rooms: accommodation.rooms.map((room) => {
                if (room.id === props.room.id) {
                    // if (props.stock?.value === null) {
                    //     const stocks = cloneDeep(room.client_stocks);
                    //     delete stocks[props.stock.date]
                    //     return {
                    //         ...room,
                    //         client_stocks: stocks
                    //     };
                    // }

                    // return {
                    //     ...room,
                    //     client_stocks: {
                    //         ...room.client_stocks,
                    //         [props.stock.date]: {...room.client_stocks[props.stock.date], value: props.stock.value || 0, stock_type: props.stock.stock_type || null}
                    //     }
                    // };
                    return {
                        ...room,
                        client_stocks: {
                            ...room.client_stocks,
                            [props.stock.date]: props.stock
                        }
                    }
                } else {
                    return room;
                }
            })
        }
    } else {
        return accommodation;
    }
});